import React from 'react';
import axios from 'axios';


class AdminLogin extends React.Component {

  state = {
    id: '',
    password: ''
  }

  componentDidMount() {
    const accessToken = localStorage.getItem('access_token');
    const expiresAt = Number(localStorage.getItem('expires_at'));
    const currentEpoch = Math.floor(Date.now() / 1000);

    if (accessToken && expiresAt && expiresAt > currentEpoch) {
      this.props.history.replace('/admin');
    }
  }

  login = () => {
    const requestBody = { id: this.state.id, password: this.state.password };

    axios.post('https://lrfiosxbs6.execute-api.ap-northeast-2.amazonaws.com/default/login', requestBody)
      .then((response) => {
        if(response.status === 200) {
          localStorage.setItem('access_token', response.data.access_token);
          localStorage.setItem('refresh_token', response.data.refresh_token);
          localStorage.setItem('expires_at', String(response.data.expires_at));
          localStorage.setItem('refresh_token_expires_at', String(response.data.refresh_token_expires_at));
          this.props.history.replace('/admin');
        }
      })
      .catch((error) => {
        console.error(error);
      });
  }

  handleChange = (e) => {
    this.setState({
      [e.target.name]: e.target.value
    });
  }

  render () {
    return (
      <div className="horizontal-layout horizontal-menu horizontal-menu-padding 1-column blank-page pace-done" style={{ minHeight: '100vh' }}>
        <div className="app-content container center-layout mt-2" style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          <div className="content-wrapper" style={{ width: '100%' }}>
              <div className="content-header row">
              </div>
              <div className="content-body">
                  <section className="flexbox-container">
                      <div className="col-12 d-flex align-items-center justify-content-center">
                          <div className="col-lg-7 col-md-9 col-11 box-shadow-2 p-0">
                              <div className="card border-grey border-lighten-3 m-0">
                                  <div className="card-header border-0">
                                      <div className="card-title text-center">
                                          <div className="p-3" style={{ fontSize: '2rem', fontWeight: 700 }}>Admin Login</div>
                                      </div>
                                  </div>
                                  <div className="card-content">
                                      <div className="card-body" style={{ padding: '2.5rem 3rem 3rem' }}>
                                          <form className="form-horizontal form-simple" action="index.html">
                                              <fieldset className="form-group position-relative has-icon-left mb-0">
                                                  <input type="text" 
                                                    className="form-control form-control-lg"
                                                    style={{ minHeight: '60px', marginBottom: '1rem' }}
                                                    name="id"
                                                    value={this.state.id}
                                                    onChange={this.handleChange}
                                                  />
                                                  <div className="form-control-position">
                                                      <i className="ft-user"></i>
                                                  </div>
                                              </fieldset>
                                              <fieldset className="form-group position-relative has-icon-left">
                                                  <input type="password" 
                                                    className="form-control form-control-lg"
                                                    style={{ minHeight: '60px', marginBottom: '1rem' }}
                                                    name="password"
                                                    value={this.state.password} 
                                                    onChange={this.handleChange}
                                                  />
                                                  <div className="form-control-position">
                                                      <i className="fa fa-key"></i>
                                                  </div>
                                              </fieldset>
                                              <button type="button" className="btn btn-primary btn-lg btn-block" style={{ minHeight: '60px', marginTop: '1rem', fontWeight: 600 }} onClick={this.login}><i className="ft-unlock"></i> Login</button>
                                          </form>
                                      </div>
                                  </div>
                              </div>
                          </div>
                      </div>
                  </section>
              </div>
          </div>
        </div>
      </div>
    );
  }
}

export default AdminLogin;
